module.exports = __webpack_public_path__ + "static/img/case-3.e76b285f.png";